import { Form } from '@ant-design/compatible'

import ManageApplicationTypeForm from './ManageApplicationTypeForm'

export default Form.create({
  name: 'applicationTypeForm',
})(ManageApplicationTypeForm)
